import React, {useContext} from "react";
import UserContext from "../../common/UserContext";
import uuid from "react-uuid";
import {cloneDeep} from "lodash";

//components
import GenericAssignModal from "../../common/AssignHost/GenericAssignModal";
import {ColumnMenu, NoWrapCell, TextAlignMiddleCell} from "../../common/Grid";
import ProductGrid from "../../common/AssignHost/GenericAssignModal/ProductGrid";

// kendo
import {GridColumn} from "@progress/kendo-react-grid";

//multilingual
import {
    descriptionKey, licenseTypeKey,
    mainMessages,
    productNumberKey, qtyKey
} from "../../../assets/text/MultilingualText";
import {useLocalization} from "@progress/kendo-react-intl";
import {AssignedProductContext, GeneralContext} from "../FSARequestLicenseContext";
import axios from "axios";
import config from "../../../config";
import moment from "moment/moment";


function AssignProductsModal(props) {
    const {
        siteLanguageDefault
    } = useContext(UserContext);

    const {
        setIsLoading,
        uniqueID,
        onePerHostKey,
        productNumKey,
        licenseStartDateKey,
        licenseEndDateKey,
        headerInfo,
        setHeaderInfo,
        preprocessNewProducts,
    } = useContext(GeneralContext);

    const {
        sortByDisableID,
    } = useContext(AssignedProductContext);

    const localization = useLocalization();

    const {
        selectID,
        hostDetails,
        setHostDetails,
        scrollRef,
        assignedProducts,
        setAssignedProducts,
        selectedProducts,
        setSelectedProducts,
        sortByDisableValue,
        sortByDisableValue2,
        setSelectHeaderCheck,
        setEnableSortByDisable,
    } = props

    let hostModal = hostDetails.hostid_type_popup.toUpperCase() || "";


    const saveHostMethod = (accessToken, setIsLoading, showError, nextMethod, hostIDs, savedHostInfo, hostDetails, serialNumber = '', hostFile = '', source = 'KSM_EXTERNAL') => {
        let headers = {
            'Authorization': 'Bearer ' + accessToken
        };

        let host_val = [];
        hostIDs.forEach((host) => {
            host_val.push(host?.trim() || '');
        })

        let products = []

        selectedProducts.forEach(product => {
            if (product[selectID]) {
                const licenseType = product['license_type'].filter(lt => lt.selected)[0]
                const saveProduct = {
                    parent_cart_id: product[uniqueID],
                    product_number: product[productNumKey],
                    product_id: product['product_id'],
                    bundle_line_id: product['bundle_line_id'],
                    hostid_type: licenseType[sortByDisableID],
                    license_type: licenseType['license_type'],
                    status: "ASSIGNED",
                    quantity: product['assign_quantity'],
                    license_start_date: moment(product[licenseStartDateKey]).format('YYYY-MM-DD HH:mm:ss'),
                    license_end_date: moment(product[licenseEndDateKey]).format('YYYY-MM-DD HH:mm:ss'),
                }
                products.push(saveProduct)
            }
        })

        let inputJSON = {
            "fsa_id": headerInfo['fsa_id'],
            "host_id_type": hostDetails.host_id_type || "",
            "host_val": host_val,
            "serial_number": serialNumber?.trim() || '',
            "alias": savedHostInfo['alias']?.trim() || '',
            "asset_info": savedHostInfo['asset_info']?.trim() || '',
            "city": savedHostInfo['city']?.trim() || '',
            "state": savedHostInfo['state']?.trim() || '',
            "country": savedHostInfo['country']?.trim() || '',
            "notes": savedHostInfo['notes']?.trim() || '',
            "products": products
        }

        let data = {
            "module": "FSA",
            "sub_module": "HOST_ASSIGN",
            "action": "SAVE",
            "input_json": inputJSON
        }

        console.log('assign host data', data)

        let formData = new FormData();
        formData.append('File', hostFile);
        formData.append('Data', JSON.stringify(data));

        setIsLoading(true);

        axios.post(
            config.ea_request_license.HOST,
            formData,
            {headers: headers}
        )
            .then((response) => {
                if (response.status === 200) {
                    nextMethod(response.data);
                }
            })
            .catch((error) => {
                console.log("ERROR: Failed to POST Host Assignment Save Host ID", error);
                let errorCode = error.response?.data?.error_code ?? "";
                switch (errorCode) {
                    case "MOD_FSA_161":
                        showError('quantityConsumed');
                        break;
                    case "MOD_EA_160":
                    case 'MOD_HSMGMNT_1':
                        showError('alias');
                        break;
                    default:
                        showError('generic');
                        break;
                }
                setIsLoading(false);
            });
    }

    /*
     * createHost() creates the accordion for the products assigned to a host
     * @param {panelBarTitle} is the assignedProduct's accordion title
     * @param {host} is the existing assignedProduct object in assignedProducts
     * @param {hostId} is the assignedProduct's host_id
     * @param {serialNumber} is the assignedProduct's serial number
     * @param {hostFile} is the file of host
     * @param {saved_db_items} returned saved items from api/database
    */
    const createHost = (panelBarTitle, host, hostId, serialNumber = "", hostFile = null, savedData) => {
        const newHeaderInfo = savedData['header_info']
        setHeaderInfo(newHeaderInfo)

        let savedProducts = savedData['save_host_response'];

        let transactionID = host ? host.transaction_id : uuid();

        let hosts = [...assignedProducts];

        // 1a. update assignedProducts for the assigned products accordions for existing host
        if (host) {

            // find index of the host in assignedProducts array
            let hostIndex = hosts.findIndex(hostUpdate => hostUpdate === host);

            //set host file if host file is empty string
            if (hosts[hostIndex].file === "") {
                hosts[hostIndex].file = hostFile
            }

            savedProducts.forEach((item) => {
                let newProduct = preprocessNewProducts(item, newHeaderInfo, "ASSIGNED")
                newProduct["panel_bar_title"] = hosts[hostIndex].panel_bar_title
                newProduct["transaction_id"] = transactionID;
                hosts[hostIndex].products.push(newProduct)
            })
            setAssignedProducts(hosts)
        }
        // 1b. update assignedProducts for the assigned products accordions for a new host
        else {
            let hostProducts = []
            savedProducts.forEach((item) => {
                let newProduct = preprocessNewProducts(item, newHeaderInfo, "ASSIGNED")
                newProduct["panel_bar_title"] = panelBarTitle
                newProduct["transaction_id"] = transactionID;
                hostProducts.push(newProduct)
            })

            const isPartial = hostModal === 'PARTIAL' ? 'Y' : 'N'

            let assignedProduct = {
                transaction_id: transactionID,
                is_partial: isPartial,
                host_id: hostId,
                serial_id: serialNumber,
                products: hostProducts,
                file: hostFile,
                panel_bar_title: panelBarTitle,
                expanded: ['.0'],
                icons: {
                    checked: true,
                },
            };

            setAssignedProducts(assignedProducts => [...assignedProducts, assignedProduct]);
        }
    }

    const resetSelectedProducts = () => {
        let newSelectedProducts = selectedProducts.map((item) => {
            if (item[selectID]) {
                item.unassigned_quantity -= item.assign_quantity;
                item.saved_assigned_quantity += item.assign_quantity;
                item.assign_quantity = item[onePerHostKey] === "Y" ? 1
                    : item.unassigned_quantity === 1 ? 1
                        : null;
            }
            item[selectID] = false
            item.disabled = false
            return item
        })

        setSelectedProducts(newSelectedProducts)
        sortByDisableValue.current = null
        sortByDisableValue2.current = null
        setSelectHeaderCheck(false)
        setEnableSortByDisable(false)
        setIsLoading(false);
        closeModal()
    }

    const closeModal = () => {
        setHostDetails({})
        // scroll to assigned products
        if (scrollRef.current) scrollRef.current.scrollIntoView({behavior: 'smooth'});
    }

    return (
        <GenericAssignModal
            onePerHost={onePerHostKey}
            productNum={productNumKey}
            selectID={selectID}
            productID={'selected_product_id'}
            createHost={createHost}
            closeModal={closeModal}
            resetSelectedProducts={resetSelectedProducts}
            saveHostMethod={saveHostMethod}
            {...props}
        >
            <ProductGrid
                items={selectedProducts.filter(item => item[selectID])}
                hostModal={hostModal}
            >
                <GridColumn
                    field={productNumKey}
                    title={localization.toLanguageString(productNumberKey, mainMessages[siteLanguageDefault][productNumberKey])}
                    cell={NoWrapCell}
                />
                <GridColumn
                    field="description"
                    title={localization.toLanguageString(descriptionKey, mainMessages[siteLanguageDefault][descriptionKey])}
                />
                <GridColumn
                    field="selected_license_type_text"
                    title={localization.toLanguageString(licenseTypeKey, mainMessages[siteLanguageDefault][licenseTypeKey])}
                    cell={NoWrapCell}
                />
                <GridColumn
                    width={"50px"}
                    field="assign_quantity"
                    title={localization.toLanguageString(qtyKey, mainMessages[siteLanguageDefault][qtyKey])}
                    cell={TextAlignMiddleCell}
                />
            </ProductGrid>
        </GenericAssignModal>
    )
}

export default AssignProductsModal;